module.exports = __webpack_public_path__ + "img/7e8a398.png";